module.exports = __webpack_public_path__ + "img/P150T_weapon_72.283bdc44.png";